import React, { useState, useEffect } from "react";
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Typography,
} from "@material-ui/core";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import styles from "../../../../styles/global-styles";
import { ProductService } from "../../../../services/product.service";
import TableHeadProductInSite from "../../../shared/table/TableHeadProductInSite";
import { changeRowsPerPage } from "../../../../_utils/utils";
import { headCellChipProductInSite } from "../../../stateless/headTables/HeadCellChipProductInSite";
import ChipInSiteRow from "../../../stateless/ChipInSiteRow";

const usetSyles = makeStyles((theme) => ({
  title: styles.title,
  subtitle: styles.subtitle,
  label: styles.label,
  rightButton: styles.buttonRightHeader,
  backgroundIcon: styles.backgroundIcon,
  customSelect: styles.customSelect,
  table: {
    minWidth: 750,
  },
  rowSelected: {
    "&:hover": {
      backgroundColor: "#ccebff !important",
    },
  },
}));

const ChipDetailInSite = ({ lote, siteId, detailAlert, addAlert }) => {
  const classes = usetSyles();
  const accesoryParams = { lote, siteId, inDistribution: 0, productSold: 0 };

  const [chipProducts, setChipProducts] = useState([]);
  const [detailProduct, setDetailProduct] = useState({});
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await ProductService.getProductByChipsWithParams(
          accesoryParams
        );
        if (data.length) {
          setChipProducts(data);
          const {
            chip: {
              iccid,
              cost,
              price,
              lote,
              id,
              chip_catalogue: { name },
            },
          } = data[0];
          const productId = data[0].id;
          setDetailProduct({
            ...detailProduct,
            iccid,
            cost,
            price,
            lote,
            chipType: name,
            accesoryId: id,
            productId,
          });
        } else {
          const errorObj = {
            noAvailable: "No hay producto disponibles para su venta",
          };
          throw errorObj;
        }
      } catch (error) {
        console.log("error", error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: error.noAvailable ? "warning" : "error",
          message: error.noAvailable ? error.noAvailable : error.msgs,
        });
      }
    })();
  }, []);

  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography className={classes.subtitle}>
            Inventario lote {lote}
          </Typography>
        </Grid>
      </Grid>

      <TableContainer style={{ marginTop: 20 }}>
        <Table className={classes.table} size={"medium"} aria-label="table">
          <TableHeadProductInSite headCells={headCellChipProductInSite} />
          <TableBody>
            {chipProducts
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((product, id) => (
                <ChipInSiteRow key={id} row={product} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={chipProducts.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={(event) => {
          const { rowsPerPage, page } = changeRowsPerPage(event);
          setRowsPerPage(rowsPerPage);
          setPage(page);
        }}
      />
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ChipDetailInSite);
